<template>
    <div class="bs-setting-wrap">
        <el-form ref="form" :model="config" label-width="90px" label-position="left" class="setting-body bs-el-form">
            <el-form :model="config.customize" label-position="left" class="setting-body bs-el-form" label-width="90px">
                <SettingTitle>标题</SettingTitle>
                <el-form-item label="装饰名称" class="lc-field-body">
                    <el-input v-model="config.title" clearable />
                </el-form-item>
                <SettingTitle>位置</SettingTitle>
                <div class="lc-field-body">
                    <PosWhSetting :config="config" />
                </div>
                <SettingTitle>基础</SettingTitle>
                <div class="lc-field-body">
                    <el-form-item label="装饰主颜色">
                        <ColorPicker v-model="config.customize.decorationColor1" :predefine="predefineThemeColors" />
                    </el-form-item>
                    <el-form-item label="装饰副颜色">
                        <ColorPicker v-model="config.customize.decorationColor2" :predefine="predefineThemeColors" />
                    </el-form-item>
                    <el-form-item label="扫描动画时长">
                        <el-input-number v-model="config.customize.scanDur" :precision="0" label="请输入时长(s)" />
                    </el-form-item>
                    <el-form-item label="光晕动画时长">
                        <el-input-number v-model="config.customize.haloDur" :precision="0" label="请输入时长(s)" />
                    </el-form-item>
                </div>
                <SettingTitle>旋转</SettingTitle>
                <div class="lc-field-body">
                    <RotateSetting :config="config" />
                </div>
            </el-form>
        </el-form>
    </div>
</template>
<script>
import ColorPicker from '@/components/data-room-ui/packages/bigScreen/ColorPicker/index.vue'
import PosWhSetting from '@/components/data-room-ui/packages/bigScreen/RightSetting/PosWhSetting.vue'
import RotateSetting from '@/components/data-room-ui/packages/bigScreen/RightSetting/RotateSetting.vue'
import SettingTitle from '@/components/data-room-ui/packages/bigScreen/SettingTitle/index.vue'
import { predefineColors } from "@/components/data-room-ui/packages/js/utils/colorList";
export default {
    name: 'BarSetting',
    components: {
        ColorPicker,
        PosWhSetting,
        RotateSetting,
        SettingTitle
    },
    data() {
        return {
            // 预设主题色
            predefineThemeColors: predefineColors
        }
    },
    computed: {
        config: {
            get() {
                return this.$store.state.bigScreen.activeItemConfig
            },
            set(val) {
                this.$store.state.bigScreen.activeItemConfig = val
            }
        }
    },
    watch: {},
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/data-room-ui/packages/assets/style/borderAndDecoraSetting.scss";

.lc-field-body {
    padding: 12px 16px;
}
</style>
